<template>
    <div :class="['reo-share-list-container', {'grey-background': !userInfo.length}]">
        <div class="pic-card">
            <div class="card">
                <p class="title">{{ $t('share.list.title') }}</p>
                <a class="btn" @click="addShare">{{ $t('share.list.addBtn') }}</a>
            </div>
        </div>
        <div class="share-table">
            <div class="title" v-if="userInfo.length">{{ $t('share.list.management') }}</div>
            <div class="cell-group">
                <cell v-for="(item, idx) in userInfo" :key="('cell-manage-' + idx)" :title="item.nickName" @click.native="itemClick(item)">
                    <div slot="foot-icon">
                        <span class="icon-icon_arrow-right"></span>
                    </div>
                </cell>
            </div>
        </div>
    </div>
</template>

<script>
import cell from '@/components/cell';
import { getDeviceShareInfo } from '@/api/share';
import { requestToApp } from '@/api/app';

export default {
    components: {
        cell
    },
    async created () {

        // 获取设备分享的信息
        this.uid = this.$route.query.uid;
        await this.getDeviceShareInfo();
        requestToApp( 'modifyPageTitle', {title: this.$t( 'share.pageTitle.share' )});

    },
    methods: {
        async getDeviceShareInfo () {

            let data = await getDeviceShareInfo( this.uid );
            console.log( 'list', data );
            this.shareInfo = data;
            this.userInfo = data && data.map( item => {

                return {...item.user, shareid: item.id, uid: item.uid, channels: item.channels};

            });

        },
        addShare () {

            this.$router.push({
                path: `/share/shareauth/${this.uid}`
            });

        },
        itemClick ( item ) {

            console.log( 'params: ' + JSON.stringify( item ));
            this.$router.push({
                path: `/share/sharedelete/`,
                query: {
                    'shareInfo': item
                }
            });

        }
    },
    data () {

        return {
            uid: '',
            shareid: '',
            userInfo: []
        };

    }
};
</script>

<style lang="less">
.reo-share-list-container {
    padding-top: .3rem;
    background-color: #ffffff;
    &.grey-background {
        background-color: #F7F8F9;
    }
    .pic-card {
        width: 6.9rem;
        height: 2rem;
        margin: 0 auto;
        box-shadow: 0 0.04rem 0.14rem rgba(141, 151, 158, 0.16);
        border-radius: 0.24rem;
        background-color: #ffffff;
        .card {
            padding: 0.58rem 0.38rem 0.35rem 0;
            text-align: right;
            background: url(~IMAGE/share/share_add_pic.png) no-repeat;
            background-position:  0.5rem 0.17rem;
            background-size: 2.66rem 1.66rem;
            .title {
                color: #333;
                font-size: 0.26rem;
                line-height: 1.5;
            }
            .btn {
                margin-top: 0.24rem;
                display: inline-block;
                font-size: 0.26rem;
                color: #009DE1;
                padding: 0.04rem 0.23rem;
                border: 0.02rem solid #009de1;
                border-radius: 1rem;
            }
        }
    }
    .share-table {
        .title {
            color: #777777;
            font-size: 0.22rem;
            line-height: 0.4rem;
            margin: 0.6rem 0.3rem 0.1rem;
            background: #FFFFFF;
        }
        .cell-group {
            .reo-cell-box:nth-child(1) {
                .reo-cell::before{
                    display: none;
                }
            }
            .icon-icon_arrow-right {
                color: #9A9DAE;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/share/shareList.vue